// Navigation context, not acquisition attribution. History may retain it on reload/back.
// The builder keeps it separate from saved preferences unless the learner opts in.
export const buildPracticeState = exams =>
  Array.isArray(exams) && exams.length > 0 && exams.every(exam => exam === 'ABSITE')
    ? {practiceExam: 'ABSITE'} : undefined;

export const resolvePracticeSeed = (state, availableExams) =>
  state?.practiceExam === 'ABSITE' && Array.isArray(availableExams) && availableExams.includes('ABSITE')
    ? 'ABSITE' : '';
